import React from "react";
import PatientJobForm from "../../forms/PatientJobForm";
import { useLocation, useParams } from "react-router-dom";
import CustomButtons from "../../ui-elements/Buttons/CustomButtons";
import { useState } from "react";
import PatientJobTable from "../../tables/PatientJobTable";
import Patients from "../../../modules/Patients";
import { useEffect } from "react";
import EditPatientsJob from "../../forms/EditPatientsJob";
import ComplaintForm from "../../forms/ComplaintForm";
import ComplaintsTable from "../../tables/ComplaintsTable";
import DoctorNotesForm from "../../forms/DoctorNotesForm";
import DoctorNotesTable from "../../tables/DoctorNotesTable";
const userInfo = JSON.parse(localStorage.getItem("user_info"));

function DoctorTreatmentNotes() {
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [complaintListData, setComplaintListData] = useState([]);
  const { id } = useParams();
const [editJobData, setEditJobData] = useState(null)
  // let patientJobDetails = JSON.parse(localStorage.getItem('patientJobDetails'));
  // const [patients, setPatients] = useState([]);
  const [categoryListStatus, setCategoryListStatus] = useState([]);
  const [patientJobDetails, setPatientJobDetails] = useState({
    firstName: "",
    lastName: "",
    patientId: "",
  });
  const [assignedData, setAssignedData] = useState([]);
  const [roleListStatus, setRoleListStatus] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const viewOnly =
    userInfo.roleName.replace(/\s/g, "").toUpperCase() === "VIEWONLY";
  const [patientLoader, setPatientLoader] = useState(false);
  const [boxShown, setBoxShown] = useState([
    {
      boxName: "Complaints Pending",
      count: 0,
      bgColor: "#DEDEDE",
      color: "#333333",
    },
    {
      boxName: "Complaints Overdue",
      count: 0,
      bgColor: "#FDD2D2",
      color: "#FE2D2D",
    },
    {
      boxName: "Complaints Due Today",
      count: 0,
      bgColor: "#C9F9C1",
      color: "#188706",
    },
  ]);

  console.log("boxShown---", boxShown);

  useEffect(() => {
    if (id) {
      id && setShowPatientForm(true);
    }
  }, [id]);

  const allPatients = (id) => {
    setPatientLoader(true);
    Patients.getAllPatients((response) => {
      if (response?.status === "success") {
        // setPatients(response?.data);
        const patientsId = response?.data.find((el) => el.id == id);
        console.log(patientsId);
        setPatientLoader(false);
        setPatientJobDetails({
          firstName: patientsId ? patientsId?.firstName : "",
          lastName: patientsId ? patientsId?.lastName : "",
          patientId: patientsId ? patientsId?.id : "",
        });
      }
    });
  };
  useEffect(() => {
    Patients.getDoctorListForAddTaskList((response) => {
      if (response?.status === "success") {
        setAssignedData(response.data);
      }
    });
  }, []);
  useEffect(() => {
    document.title = "Complaints Tracker - LDC";
    if (id) {
      allPatients(id);
    }
    getComplaintsDetailsPatient();
    getCaegoryListStatus();
    getRoleListStatus();
  }, [id]);

  const getComplaintsDetailsPatient = (data) => {
    if (!data) return;
    console.log("data---<><>", data);
    console.log("data.complaintStatus", data.complaintStatus);
    setComplaintListData(data?.data || []);

    // Create a map from the API response
    // const complaintStatusMap = data.complaintStatus.reduce((acc, item) => {
    //   acc[item.status] = item.statusCount;
    //   return acc;
    // }, {});

    // // Update boxShown dynamically
    // setBoxShown([
    //   {
    //     boxName: "Complaints Pending",
    //     count: complaintStatusMap["Complaints Pending"] || 0,
    //     bgColor: "#DEDEDE",
    //     color: "#333333",
    //   },
    //   {
    //     boxName: "Complaints Overdue",
    //     count: complaintStatusMap["Complaints Overdue"] || 0,
    //     bgColor: "#FDD2D2",
    //     color: "#FE2D2D",
    //   },
    //   {
    //     boxName: "Complaints Due Today",
    //     count: complaintStatusMap["Complaints Due Today"] || 0,
    //     bgColor: "#C9F9C1",
    //     color: "#188706",
    //   },
    // ]);
  };

  const checkingData = (dateString) => {
    // Parse the due date string into a Date object
    const dueDate = new Date(dateString);

    // Get today's date
    const today = new Date();

    // Compare due date with today's date
    if (dueDate < today) {
      // Task is overdue
      // console.log("Task is overdue");
      return -1;
    } else if (dueDate > today) {
      // Task is pending
      // console.log("Task is pending");
      return 0;
    } else {
      // Task is due for today
      // console.log("Task is due for today");
      return 1;
    }
  };
  const getCaegoryListStatus = () => {
    setLoading1(true);
    Patients.getCategoryListStatus((response) => {
      if ((response.status = "success")) {
        setLoading1(false);
        setCategoryListStatus(response.data);
      }
    });
  };
  const getRoleListStatus = () => {
    setLoading2(true);
    Patients.getRoleListStatus((response) => {
      if ((response.status = "success")) {
        setLoading2(false);
        setRoleListStatus(response.data);
      }
    });
  };

  // console.log(assignedData)
  return (
    <div>
      {/* {location.state === null && ( */}
      <>
        {!loading1 && !loading2 && !loading3 && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <CustomButtons
              style={{ width: "180px" }}
              onClick={() => setShowPatientForm(!showPatientForm)}
              variant="primary"
              name={showPatientForm ? "Close Form" : "Add New Note"}
              disabled={viewOnly}
            />
            {/* <CustomButtons onClick={()=>window.location.reload(false)} variant="primary" name="Refresh" /> */}
          </div>
        )}

        {showPatientForm && (
          <DoctorNotesForm
            assignedData={assignedData}
            getComplaintsDetailsPatient={getComplaintsDetailsPatient}
            patientJobDetails={patientJobDetails}
            setShowPatientForm={setShowPatientForm}
            getCaegoryListStatus={getCaegoryListStatus}
            getRoleListStatus={getRoleListStatus}
            patientLoader={patientLoader}
            editJobData={editJobData}
           
          />
        )}
      </>

      <DoctorNotesTable
        assignedData={assignedData}
        getComplaintsDetailsPatient={getComplaintsDetailsPatient}
        complaintListData={complaintListData}
        categoryListStatus={categoryListStatus}
        getCaegoryListStatus={getCaegoryListStatus}
        roleListStatus={roleListStatus}
        getRoleListStatus={getRoleListStatus}
        loading1={loading1}
        loading2={loading2}
        loading3={loading3}
        // setShowPatientForm={setShowPatientForm}
            setEditJobData={setEditJobData}

      />
    </div>
  );
}

export default DoctorTreatmentNotes;
